import script from "./PageHero.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageHero.vue?vue&type=script&setup=true&lang=ts"

import "./PageHero.vue?vue&type=style&index=0&id=fac12e24&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fac12e24"]])

export default __exports__